import { render, staticRenderFns } from "./PartnerClasses.vue?vue&type=template&id=277062fb&scoped=true"
import script from "./PartnerClasses.vue?vue&type=script&lang=js"
export * from "./PartnerClasses.vue?vue&type=script&lang=js"
import style0 from "./PartnerClasses.vue?vue&type=style&index=0&id=277062fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277062fb",
  null
  
)

export default component.exports